import React from 'react';
import ReactTable from 'react-table';
import styled, { css } from 'styled-components';
import { divider, gridError, secondValueColor, tableOdd, yellow } from 'styles/Colors';

export const StyledReactTable = styled((props) => <ReactTable {...props} />)`
  &&& {
    box-shadow: none !important;
    .rt-table {
      z-index: 1;

      .rt-tbody .rt-tr-group .rt-tr {
        height: 51px;

        .rt-td:first-child {
          height: auto;
          border-right: 1px solid #f5f5f5;
        }

        &.-odd,
        &.-odd .rt-td {
          background: ${divider} !important;
        }
      }
      .rt-tr {
        font-size: 13px;
        line-height: 30px;
        overflow: hidden;
        display: flex;

        .rt-th {
          font-weight: 700;
        }

        .rt-td,
        .rt-th {
          height: 100%;
          line-height: 28px;
          padding: 0;
          font-size: 13px;
          text-align: center;

          border-right: none;
        }
        .rt-th:first-of-type {
          text-align: left;
        }
      }

      .rt-thead .rt-tr {
        height: 35px;

        .rt-th {
          display: flex;
          align-items: center;
          padding-left: 10px;
        }
      }

      .content-cell {
        height: 100%;
      }

      .name-cell {
        text-align: left;
        padding-left: 8px;
      }

      .selected {
        border: 1px solid #03a9f4;
        background-color: rgba(3, 169, 244, 0.04);
      }
    }
    .name-cell {
      .name-checkbox {
        .checkbox {
          margin-top: 3px;
        }
        .label {
          line-height: 28px;
        }
      }
      &.discrepant {
        border-color: ${yellow};
        width: 100%;
        padding-left: 0;
        padding-right: 0;
        margin: none;
      }
    }
    .discrepant {
      height: 100%;
      box-sizing: border-box;
      border: 2px solid ${gridError};
      border-radius: 4px;
      width: fit-content;
      padding-left: 4px;
      padding-right: 4px;
      margin: 0 auto;
    }
    .rt-noData {
      background: transparent;
    }
  }
`;

export const TeamName = styled.div`
  font-size: 13px;
  font-weight: 700;
`;

export const PositionName = styled.div`
  font-size: 11px;
  font-weight: 700;
  color: #7b7b7b;
`;

export const TeamPositionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SecondValue = styled.div`
  font-size: 11px;
  color: ${secondValueColor};
`;

export const SourceValue = styled.div`
  height: 21px;
`;
